<template>
  <!-- 
    name: 覃刚
    function: 营养指标管理
    date: 2021-03-15
 -->
  <div class="listContent">
    <a-form :form="form" class="headForm">
      <a-row :gutter="24">
        <a-col :span="6">
          <a-form-item label="营养指标">
            <a-input
              v-decorator="['keyword']"
              @pressEnter="
                getList({ current: 1, pageSize: pagination.pageSize })
              "
              placeholder="输入指标名称/代码"
            />
          </a-form-item>
        </a-col>

        <a-col :span="6">
          <a-form-item label="指标类型">
            <a-cascader
              v-decorator="['typeArr']"
              :options="typeList"
              :load-data="loadData"
              placeholder="选择指标类型"
              change-on-select
              @change="onChange"
            />
          </a-form-item>
        </a-col>

        <a-col :span="6" class="submitBtnBox">
          <a-button
            type="primary"
            class="btnMar"
            @click="getList({ current: 1, pageSize: pagination.pageSize })"
          >
            查询
          </a-button>
          <a-button class="btnMar2" @click="resetFields"> 清空 </a-button>
        </a-col>
      </a-row>
    </a-form>

    <div class="editBox">
      <!-- <a-button type="primary" @click="showAddFunc">
        添加
      </a-button>
      <a-button @click="deleteData" type="danger" ghost>
        移出
      </a-button> -->
      <!-- <a-button @click="synchronization">
        同步指标
      </a-button> -->
    </div>
    <a-table
      ref="listRef"
      :scroll="{ y, x: 1000 }"
      :columns="columns"
      :data-source="list"
      class="tableBox"
      :pagination="pagination"
    >
      <div slot="name6" slot-scope="text, record, index">
        <template>
          <a @click="scanPriceList(text, record, index)">查看</a>
        </template>
      </div>
      <a
        slot="fullName"
        slot-scope="text, record, index"
        @click="scanPriceList(text, record, index)"
        >{{ text }}</a
      >
    </a-table>
    <!-- 新增 -->
    <a-modal
      title="营养指标"
      :visible="showAdd"
      :confirm-loading="confirmLoading"
      @ok="addSubmit"
      @cancel="showAddFunc"
      cancelText="取消"
      okText="确定"
      :maskClosable="false"
      width="800px"
    >
      <NutrientAdd ref="add" />
    </a-modal>
  </div>
</template>
<script>
import NutrientAdd from './NutritionalIndicator/MaterialAdd'
export default {
  components: {
    NutrientAdd
  },
  data() {
    return {
      y: 500,
      form: this.$form.createForm(this, { name: 'rawMaterialList' }),
      typeList: [],
      selectList: [],
      confirmLoading: false,
      showAdd: false,// 是否显示新增
      showEdit: false,// 是否显示编辑
      formItemLayout: {
        labelCol: { span: 7 },
        wrapperCol: { span: 17 },
      },
      pagination: {
        pageSizeOptions: ["10", "20", "30", "40", "50", "100"],
        total: 0,
        pageSize: 0,
        current: 1,
        showSizeChanger: true,
        showTotal: (total) => `共${total}条记录`,
        onChange: (current, pageSize) => {
          this.pagination.current = current
          this.getList({ current, pageSize })
        },//选择页数
        onShowSizeChange: (current, pageSize) => {
          this.pagination.current = 1
          this.pagination.pageSize = pageSize
          window.localStorage.setItem('nutritionalIndicatorPageSize', pageSize)
          this.getList({ current: 1, pageSize })
        } //每页多少条
      },
      list: [],
      columns: [
        {
          title: '指标全称',
          dataIndex: 'fullName',
          scopedSlots: { customRender: 'fullName' },
        },
        {
          title: '代码',
          dataIndex: 'code'
        },
        {
          title: '指标名称',
          dataIndex: 'name'
        },
        {
          title: '类型',
          dataIndex: 'typeName'
        },
        {
          title: '单位',
          dataIndex: 'unit'
        },
        {
          title: '操作',
          dataIndex: 'name6',
          scopedSlots: { customRender: 'name6' },
        }
      ],
    }
  },
  computed: {
    pageSizeC() {
      let pageSize = window.localStorage.getItem('nutritionalIndicatorPageSize')
      let pageSizeC = pageSize ? Number(pageSize) : 20
      return pageSizeC
    },
    rowSelection() {
      return {
        onChange: (selectedRowKeys) => {
          this.selectList = selectedRowKeys
        },
        // onSelect: (record, selected, selectedRows) => {
        //   console.log(record, selected, selectedRows);
        //   this.selectList = selectedRows
        // },
        // onSelectAll: (selected, selectedRows, changeRows) => {
        //   console.log(selected, selectedRows, changeRows);
        //   this.selectList = selectedRows
        // },
        selectedRowKeys: this.selectList
      }
    }
  },
  mounted() {
    this.getList()
    this.getTypeList()
    this.y = this.$refs.listRef.$el.offsetHeight - 116
  },
  methods: {
    synchronization() {
      this.$post('/nhf-app/formulaManage/repairAllFormula')
    },
    loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      targetOption.loading = true;
      setTimeout(() => {
        targetOption.loading = false;
        // this.$emit('getTypeList',{targetOption,id:targetOption.id})
        this.getTypeList(targetOption.id, targetOption) || []
        // this.typeList = [...this.typeList];
      }, 0);
    },
    onChange(value) {
      console.log(value);
    },
    getList(pagination) {
      this.selectList = []
      let { current = 1, pageSize } = pagination || {}
      pageSize = pageSize ? pageSize : this.pageSizeC
      let factoryId = window.localStorage.getItem('factoryId')
      this.form.validateFields((err, data) => {
        let { typeArr = [], ...newdata } = data
        let params = {
          ...newdata,
          factoryId,
          current,
          size: pageSize,
          typeId: typeArr.length ? typeArr[typeArr.length - 1] : undefined
        }
        this.$http.get('/nhf-app/factorystaffnutritionraw/selectNutritionWithoutSpecialTypePage', { params }).then(res => {
          let { success, data } = res;
          if (success) {
            let { records, current = 1, total = 0, size } = data;
            this.pagination.current = current
            this.pagination.total = total
            this.pagination.pageSize = size
            records && records.map(el => {
              el.edit = false
            })
            this.list = records || []
            this.oldList = JSON.parse(JSON.stringify(records))
          } else {
            this.$message.error('查询失败')
          }
        })
      })
    },
    resetFields() {
      this.form.resetFields()
    },
    refreshTypeList(data) {
      this.getTypeList(data.id, data.targetOption)
    },
    getTypeList(parentId = 0, record) {
      // 获取片区id
      let obj = window.localStorage.getItem('factoryDetail')
      let factoryDetail = obj ? JSON.parse(obj) : {}
      let { deptId } = factoryDetail
      // this.$http.get(`/nhf-core-data/basictype/listByParentIdWithOutSpecialTypeId?category=nutritiontarget&parentId=${parentId}`)
      this.$http.get(`/nhf-core-data/basictype/listByParentIdWithOutSpecialTypeIdAndSatlimit?category=nutritiontarget&parentId=${parentId}&deptId=${deptId}`)
        .then(res => {
          let { success, data = [] } = res;
          if (success) {
            data && data.map(el => {
              el.value = el.id
              el.label = el.name
              el.isLeaf = !el.hasChildren
              // el.isLeaf = false
              return el
            })
            if (record) {
              if (data.length) {
                record.children = data
              } else {
                record.isLeaf = true
              }
              this.typeList = [...this.typeList];
            } else {
              this.typeList = data
            }
            // this.typeList = data
            // return data
          } else {
            this.typeList = []
          }
        })
    },
    editRow(record, val) {
      // 编辑行
      record.edit = val
    },
    deleteData() {
      if (this.selectList.length) {
        this.$confirm({
          title: '提示',
          content: '确认将选中的原料删除吗？',
          cancelText: '取消',
          okText: '确定',
          onOk() {
            console.log('删除成功。')
          },
          onCancel() {
            console.log('取消删除。')
          },
        });
      } else {
        this.$message.warning('请选中要删除的数据')
      }

    },
    scanPriceList(text, record) {
      // 查看价格
      this.$store.commit('saveMenuInformation', { name: record.name, hierarchy: 3 })
      this.$router.push(`/mainPage/nutritional-indicator/index-view?name=${record.name}&id=${record.id}`)
    },
    addSubmit() {
      // 新增提交
      // console.log()
      this.$refs['add'].form.validateFields((err, values) => {
        console.log(values)
      })
      this.showAddFunc()
    },
    showAddFunc() {
      // 新增显示或关闭
      this.showAdd = !this.showAdd
    },
    editSubmit() {
      // 编辑提交
      this.$refs['edit'].form.validateFields((err, values) => {
        console.log(values)
      })
      this.showEditFunc()
    },
    showEditFunc(type) {
      // 编辑显示或关闭
      if (type === 'edtiBtn') {
        if (this.selectList.length > 1) {
          this.$message.warning('编辑只能选中一条数据')
        } else if (this.selectList.length === 0) {
          this.$message.warning('请选中需要编辑的数据')
        } else {
          this.showEdit = !this.showEdit
        }
      } else {
        this.showEdit = !this.showEdit
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.listContent {
  .tableBox {
    height: calc(100% - 116px);
  }
}
</style>